<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import { onMounted } from 'vue'

defineProps({
    cookies: String,
})

onMounted(() => {
    // SSR-safe kontrola existence document
    if (typeof document !== 'undefined') {
        const markdownEl = document.querySelector('.markdown-content')
        if (markdownEl) {
            const links = markdownEl.querySelectorAll('a')

            links.forEach((link) => {
                link.setAttribute('target', '_blank')
                link.setAttribute('rel', 'noopener noreferrer')
            })
        }
    }
})
</script>

<template>
    <AppLayout
        meta_title="Zásady používání cookies."
        meta_description="Sadrokartony s.r.o. Informace o používání cookies na webu J&M Sadrokartony. Zjistěte, jaké soubory cookies využíváme a proč - přečtěte si více v našich zásadách."
    >
        <template #content>
            <section class="mt-20 bg-zinc-100 pt-4 pb-10">
                <div class="flex min-h-screen flex-col items-center pt-6 sm:pt-0">
                    <div
                        class="markdown-content prose mt-6 w-full overflow-hidden bg-white p-6 text-black shadow-md ring-1 ring-white/10 sm:max-w-2xl sm:rounded-3xl sm:p-8"
                        v-html="cookies"
                    />
                </div>
            </section>
        </template>
    </AppLayout>
</template>
